import React from "react";
import { useSelector } from "react-redux";
import "../table.scss";
import { MainTable, TableWrapper } from "../styles";
import { Skeleton } from "@mui/material";
import NoData from "components/nodata";
import { useHistory } from "react-router-dom";

const ImageAssetsTable = () => {
  const history = useHistory();
  const { loading, imageAssets } = useSelector((state) => state.aff_assets);

  const renderImageAssetsData = () => {
    return loading ? (
      <>
        <tr>
          <td>
            <Skeleton />
          </td>
          <td>
            <Skeleton />
          </td>
          <td>
            <Skeleton />
          </td>
          <td>
            <Skeleton />
          </td>
        </tr>
        <tr>
          <td>
            <Skeleton />
          </td>
          <td>
            <Skeleton />
          </td>
          <td>
            <Skeleton />
          </td>
          <td>
            <Skeleton />
          </td>
        </tr>
        <tr>
          <td>
            <Skeleton />
          </td>
          <td>
            <Skeleton />
          </td>
          <td>
            <Skeleton />
          </td>
          <td>
            <Skeleton />
          </td>
        </tr>
        <tr>
          <td>
            <Skeleton />
          </td>
          <td>
            <Skeleton />
          </td>
          <td>
            <Skeleton />
          </td>
          <td>
            <Skeleton />
          </td>
        </tr>
      </>
    ) : (
      imageAssets.map((asset) => {
        const { campaignId: id, assetId, campaignName, noOfAsset } = asset;
        return (
          <tr
            style={{ cursor: "pointer" }}
            key={id}
            onClick={() =>
              history.push(
                `/affiliate/marketing-assets/image-assets/download/${assetId}`
              )
            }
          >
            <td>
              <label class="customContainer">
                <input type="checkbox" />
                <span class="customCheckmark"></span>
              </label>
            </td>
            <td>{campaignName}</td>
            <td>{assetId}</td>
            {/* <td>
                {loadingId === id? (
                  <Skeleton />
                ) : (
                  formatDate(new Date(createdAt), "dd, mm, yyyy")
                )}
              </td> */}
            <td>{noOfAsset}</td>
          </tr>
        );
      })
    );
  };

  const renderImageAssetsHeader = () => {
    let header = ["", "campaign", "asset ID", "number of assets"];
    return header.map((key, index) => {
      return <th key={index}>{key}</th>;
    });
  };

  return (
    <>
      {imageAssets.length === 0 && !loading ? (
        <NoData />
      ) : (
        <TableWrapper>
          <MainTable>
            <tbody>
              <tr
                style={{
                  width: "100%",
                }}
              >
                {renderImageAssetsHeader()}
              </tr>
              {renderImageAssetsData()}
            </tbody>
          </MainTable>
        </TableWrapper>
      )}
    </>
  );
};

export default ImageAssetsTable;
